import { IHesapBilgileri } from "./finance.model";

export interface IOdemeAl extends IHesapBilgileri {
    kasaBanka: Array<IKasaBanka>;
    hesapID: number;
    karsiHesapID: number;
    hareketTurID: number;
    tesisID: number;
    masrafID: number;
    tarih: Date;
    aciklama: string;
}

export interface IAltHesap {
    altHesapTurID: number;
    altHesapTuru: string;
    kalan: number;
    tutar: number;
}

export interface IKasaBanka {
    hesapID: number;
    hesapAdi: string;
    hareketTurID: number;
}
export class OdemeAlFilter {
    tahsilatTarihi: string;
    karsiHesapID: number;
    hesapAdi: string;
    bakiye: number;
    tutar: string;
    masrafID: number;
    kasaBanka: IKasaBanka;
    aciklama: string;
}